import { NavLink } from "react-router-dom";

export default function DashboardSideNav() {
    return (
      <div className="sidebar">
        <div className="sidebar-header">
          <div className="logo">
            <span className="logo-text">wengmack</span>
          </div>
        </div>
  
        <nav className="sidebar-nav">
          <NavLink
            to="/dashboard"
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          >
            <span className="nav-icon"><i className="bi bi-house"></i></span>
            <span>home</span>
          </NavLink>
  
          <NavLink
            to="/payments"
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          >
            <span className="nav-icon"><i className="bi bi-credit-card"></i></span>
            <span>payments</span>
          </NavLink>
  
          <NavLink
            to="/transactions"
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          >
            <span className="nav-icon"><i className="bi bi-arrow-down-up"></i></span>
            <span>transactions</span>
          </NavLink>
  
          <NavLink
            to="/saving-plans"
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          >
            <span className="nav-icon"><i className="bi bi-boxes"></i></span>
            <span>saving plans</span>
          </NavLink>
  
          <NavLink
            to="/investments"
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          >
            <span className="nav-icon"><i className="bi bi-graph-up"></i></span>
            <span>investments</span>
          </NavLink>
  
          <NavLink
            to="/help"
            className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
          >
            <span className="nav-icon"><i className="bi bi-question-circle"></i></span>
            <span>help</span>
          </NavLink>
        </nav>
      </div>
    );
}